/** Shared date/time formatting for the outreach board and detail dialog. */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function daysSinceLabel(days: number | null | undefined): string {
  if (days === null || days === undefined) return "Never touched";
  if (days === 0) return "Touched today";
  if (days === 1) return "1 day since touch";
  return `${days} days since touch`;
}
